import defaultFetch from 'isomorphic-unfetch'
import { UserProfileData } from '../domain/types'
import { UserProfileAPIResponse, UserProfileUpdatePayload } from './types'
import { userProfileMapper } from './userProfileMapper'

interface Dependencies {
  env: {
    NEXT_PUBLIC_API_BASE_URL: string
  }
  fetch: typeof defaultFetch
}

export function createUserProfileApiClient(dependencies: Partial<Dependencies> = {}) {
  const {
    env = { NEXT_PUBLIC_API_BASE_URL: process.env.NEXT_PUBLIC_API_BASE_URL },
    fetch = defaultFetch,
  } = dependencies as Dependencies

  async function getUserProfile(): Promise<UserProfileData> {
    const response = await fetch(`${env.NEXT_PUBLIC_API_BASE_URL}/CustomerApi/GetCustomerSelf`)
    if (!response.ok) {
      throw new Error('Error fetching profile')
    }
    const data: UserProfileAPIResponse = await response.json()
    return userProfileMapper(data)
  }

  async function updateUserProfile(payload: UserProfileUpdatePayload): Promise<UserProfileData> {
    const response = await fetch(`${env.NEXT_PUBLIC_API_BASE_URL}/CustomerApi/UpdateCustomerSelf`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(payload),
    })
    if (!response.ok) {
      throw new Error('Error updating profile')
    }
    const data: UserProfileAPIResponse = await response.json()
    return userProfileMapper(data)
  }

  return {
    getUserProfile,
    updateUserProfile,
  }
}

export default createUserProfileApiClient()
